import { render, staticRenderFns } from "./VoucherDataTable.vue?vue&type=template&id=efb444ee&scoped=true&"
import script from "./VoucherDataTable.vue?vue&type=script&lang=ts&"
export * from "./VoucherDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb444ee",
  null
  
)

export default component.exports